import { createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../../api/services/auth';
import { LOCAL_STORAGE_REFRESH_TOKEN } from '../../../utils/constants';

export const signUp = createAsyncThunk('auth/register', async requestData => {
  return await authService.signUp(requestData);
});

export const login = createAsyncThunk('auth/login', async requestData => {
  return await authService.login(requestData);
});

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: 'logout' });
  const refreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN);
  return await authService.logout(refreshToken);
});

export const verifyEmail = createAsyncThunk('auth/verifyEmail', async requestData => {
  return await authService.verifyEmail(requestData);
});

export const sendRecoveryCodeForgotPassword = createAsyncThunk(
  'auth/sendRecoveryCodeForgotPassword',
  async requestData => {
    return await authService.sendRecoveryCodeForgotPassword(requestData);
  },
);
export const changePassword = createAsyncThunk('auth/changePassword', async requestData => {
  return await authService.changePassword(requestData);
});

export const renewCodeForVendor = createAsyncThunk('auth/renewCodeForVendor', async requestData => {
  return await authService.renewCodeForVendor(requestData);
});
